import { ComponentRef, ElementRef, Type } from "@angular/core";
import { MenuItemDef, RowClassParams, RowStyle } from "ag-grid-community";
import { DynamicPipe } from "app/shared/pipes/dynamic.pipe";
import { MenuItem } from "primeng/api";
import { Observable } from "rxjs";


//#region Export classes
export enum ButtonEnableOption {
    always,
    inSingleSelect,
    inMultySelect
}
export enum ButtonDisplayOption {
    always,
    inSingleSelect,
    inMultiSelect
}
//#region buttons
export interface CustomButton {
    buttonType: ButtonType;
    label: string,
    displayOptions: ButtonDisplayOption,
    enableOptions: ButtonEnableOption,
    icon: string,
    onClick: any,
    tooltip: string,
    menuItems: ExportOptionsList[]

    //apiAddress:string 
}
//#endregion

//#region columns

export interface CustomColumnParams {
}

export class EnumParams implements CustomColumnParams {
    enumType: any;
    constructor(enumType: any) {
        this.enumType = enumType;
    }
}

export class ButtonParams implements CustomColumnParams {
    text: string;
    //class:any;
    clickCallback: (any) => any;
    //classCondition:any;
    constructor(text: string, cClass: any, classCondition: any, clickCallback: (any) => any) {
        this.text = text;
        //this.class = cClass;
        this.clickCallback = clickCallback;
        //this.classCondition=classCondition;
    }
}
export class CheckboxIcon implements CustomColumnParams {
    trueIcon: string;
    falseIcon: any;
    clickCallback: (any) => any;
    constructor(trueIcon: string, falseIcon: string, clickCallback: (any) => any) {
        this.trueIcon = trueIcon;
        this.falseIcon = falseIcon;
        this.clickCallback = clickCallback;
    }
}

export class TemplateParams implements CustomColumnParams {
    constructor(private view: ElementRef<any>) { }
}

//#endregion

//#endregion

//#region Export interfaces
export interface DropdownFilter {
    options: any[];
    //optionsResponse$:Observable<any>;
    selectedData: any;
    optionLabel: string;
    optionValue: string;
    filterName: string;
    singleClickEdit: true;
}

export interface ColumnOptions {
    field: string;
    headerName: string;
    filter: FilterType;
    type: ColumnType;
    customColumnParams: CustomColumnParams;
    cellRendererParams: object,
    sortable: boolean; // = true,
    editable: boolean; // = false
    hideColumn: CallableFunction; // = () => false
    style: any[]; // = []
    customFilterParams: any; // = {},
    headerComponentParams: any,
    onClick: any,
    cellClassRules: any;
    width: number;
    valueFormatter: any
}
export interface StatusOptions {
    statusEnumType: any;
    statusList: any[];
    selectedStatus: any;
    onChange: CallableFunction;
}
export interface GridOptions {
    gridType: DataLoadType //server
    rowSelectionType: RowSelectionType //= RowSelectionType.multiple;
    multiSort: boolean //= true;
    buttons: CustomButton[];
    status: Partial<StatusOptions>
    dropdownfilter: DropdownFilter,
    fitColumns: boolean // = false,
    sortable: boolean, // = trueת
    showSearch: boolean // = false,
    onCellValueChanged: (event: any) => void,
    contextMenu: (string | MenuItemDef)[],
    getRowStyle: (params: RowClassParams<any, any>) => RowStyle,
    rowStyle: any
    usingTopCalendar: boolean // = false,
    showSelectionColumn: boolean // = true,
    displayTitle: boolean;
    masterDetail: boolean;
    frameworkComponents;
    masterDetailsComponent;
    selectFirstRow: boolean; // = false
}
export interface loadDataParameter {
    filter: filter[],
    sort: sort[],
    Pagination: Pagination,
    freeSearchText: string,
    status: any
}
export interface filter {
    Operator: CompareType,
    Field: string,
    FieldType: FieldType,
    Value: string,
}
export interface sort {
    Field: string,
    SortType: SortType
}
export interface Pagination {
    Limit: number,
    PageIndex: number
}
export interface PipeRendererParams {
    prefix: { field: string, sep: string, value: string },
    suffix: { field: string, sep: string, value: string },
    pipe: { type: Type<any>, params: any[] },
    class: string[],
}
//#endregion

//#region Export enums

export enum ButtonType {
    Delete,
    New,
    Export,
    View,
    FilterDisplay,
    Custom,
    Screenshot,
    ViewImages

}
export enum SortType {
    asc = 1,
    desc = 2,
}
// export enum ColumnType {
//     Defualt,
//     IconBool,
//     Bool,
//     Enum
// }
export enum ColumnType {
    Defualt,
    Enum,
    Pipe,
    Template,
    Button,
    Checkbox,
    CheckboxIcon,
    Boolean,
    Link,
    Model,
    Distance,
    Combined
}
export enum CompareType {
    contains = 0,
    equals = 1,
    between = 2,
}
export enum DataLoadType {
    local = 1,
    server
}
export enum RowSelectionType {
    multiple = 1,
    single
}
export enum FilterType {
    date = "agDateColumnFilter",
    text = "agTextColumnFilter",
    number = "agNumberColumnFilter",
    set = "agSetColumnFilter",
    customDate = "agDateColumnFilter"
}
export enum CellStyle {
    date = 1,
    credit = 2,
    notValid = 3,
    button = 4
}
export enum FilterMode {
    show,
    hidden
}
export enum FieldType {
    date,
    string,
    enum,
    dateRange
}
//#endregion

//#region Export properties

export let defualtGridOptions: GridOptions = {
    gridType: DataLoadType.server,
    rowSelectionType: RowSelectionType.multiple,
    multiSort: true,
    buttons: [],
    status: null,
    dropdownfilter: null,
    fitColumns: false,
    sortable: true,
    showSearch: true,
    onCellValueChanged: (event: any) => { },
    contextMenu: [],
    getRowStyle: null,
    rowStyle: {},
    masterDetail: false,
    usingTopCalendar: false,
    showSelectionColumn: true,
    displayTitle: true, 
    frameworkComponents: null,
    masterDetailsComponent:null,
    selectFirstRow: false,
};
export let defualtColumnOptions: ColumnOptions = {
    field: "",
    headerName: "",
    filter: null,
    type: ColumnType.Defualt,
    customColumnParams: null,
    cellRendererParams: null,
    sortable: true,
    editable: false,
    hideColumn: () => false,
    style: [],
    customFilterParams: {},
    headerComponentParams: {},
    onClick: null,
    cellClassRules: null,
    width: null,
    valueFormatter: null
    // iconBoolType: null
};
export let deleteButton: CustomButton = {
    buttonType: ButtonType.Delete,
    label: null,
    displayOptions: ButtonDisplayOption.always,
    enableOptions: ButtonEnableOption.inMultySelect,
    icon: "pi pi-trash",
    onClick: null,
    tooltip: "GRID.HEADER.TOOLTIP.DELETE",
    menuItems: null

};
export let newButton: CustomButton = {
    buttonType: ButtonType.Delete,
    label: null,
    displayOptions: ButtonDisplayOption.always,
    enableOptions: ButtonEnableOption.always,
    icon: "pi pi-plus-circle",
    onClick: null,
    tooltip: "GRID.HEADER.TOOLTIP.ADD",
    menuItems: null

};

export let screenshotButton: CustomButton = {
    buttonType: ButtonType.Screenshot,
    label: null,
    displayOptions: ButtonDisplayOption.always,
    enableOptions: ButtonEnableOption.always,
    icon: "pi pi-camera",
    onClick: null,
    tooltip: null,
    menuItems: null
};

export let viewImagesButton: CustomButton = {
    buttonType: ButtonType.ViewImages,
    label: null,
    displayOptions: ButtonDisplayOption.always,
    enableOptions: ButtonEnableOption.always,
    icon: "pi pi-images",
    onClick: null,
    tooltip: null,
    menuItems: null
};

export let exportButton: CustomButton = {
    //apiAddress: string ,

    buttonType: ButtonType.Export,
    label: "GRID.HEADER.TOOLTIP.EXPORT",
    enableOptions: ButtonEnableOption.always,
    displayOptions: ButtonDisplayOption.always,
    icon: "",
    onClick: null,
    tooltip: "",
    menuItems: null
};
export let viewButton: CustomButton = {
    buttonType: ButtonType.View,
    label: null,
    enableOptions: ButtonEnableOption.inSingleSelect,
    displayOptions: ButtonDisplayOption.always,
    icon: "file-excel",
    onClick: null,
    tooltip: "",
    menuItems: null

};
export let pipeRendererParams: PipeRendererParams = {
    prefix: {
        field: "",
        sep: "",
        value: ""
    },
    suffix: {
        field: "",
        sep: "",
        value: ""
    },
    pipe: {
        type: null,
        params: []
    },
    class: []
}

export class ExportOptionsList {
    label: string;
    onClick: () => any;
    fileName?: string;

}

//#endregion

